import React, { useEffect, useRef, useState } from 'react';
import { Table, Button, Row, Col, Spinner, Dropdown, Form, Modal } from 'react-bootstrap';
import { faCheck, faEllipsisV, faExternalLinkSquareAlt, faLink, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DashLayoutCanvas from '../functionalComponents/DashboardLayout/DashboardLayoutCanvas';
import DashLayout from '../functionalComponents/DashboardLayout/DashboardLayout';
import DashRouters from '../../configs/routers/dashboard-routers.json';
import Drawer from './Drawer';

import devIcon from '../../assets/img/ui_icons/cmd_flow_on.svg'
import ObexRequestHandler from '../../handlers/ObexRequestsHandler';
import Organizations from '../../newViews/avapCloud/organizations';
import SessionService from '../../services/SessionsService';
import config from '../../configs/appConfig.json';
import { useHistory } from 'react-router-dom';
import ConfirmDeletetModal from '../Modals/ConfirmDeleteModal';
import Nodata from './components/Nodata';
import UpgradePlanModal from '../Modals/UpgradePlanModal';
import { setTimeout } from 'timers';
import Cookies from 'universal-cookie';
import FlowsForm from './FlowsForm';


// Tipo para un Proxy
type DevPortal = {
  id?: string;
  basePath: string;
  name: string;
  description: string;
  products: any[];
  projects: any[];
  normal_access: boolean;
  config: any;
  environment: any;
  has_sandbox: any;
  open: boolean;
};

const Flow = () => {

  const [loadingApiProducts, setLoadingApiProducts] = useState(false);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editingProxy, setEditingProxy] = useState(null);

  const [endpointConfig, setEndpointConfig] = useState<DevPortal | null>(null);


  const [filteredProxies, setFilteredProxies] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [certsT, setCertsT] = useState([]);
  const [apis, setApis] = useState([]);
  const [editingFlow, setEditingFlow] = useState(false)

  const [selected_service, SetSelectedService] = useState('')

  const [apiProducts, setApiProducts] = useState([]);

  const [limitDevPortals, setLimitDevPortal] = useState(50)
  const [initialized, setInitialized] = useState(false);
  const [currentSuscription, SetCurrentsuscripcion] = useState(0);
  const handleClose2 = () => {
    setshowModal(false);
  }


  const handleClose2bin = () => {
    setshowModalBin(false);
  }

  const [selectedProjectId, setSelectedProjectId] = useState('');
  const [valueBin, setvalueBin] = useState('');

  const [showModal, setshowModal] = useState(false)

  const [showModalBin, setshowModalBin] = useState(false)

    const [showUpgrade, setshowUpgrade] = useState(false)

     const [index, setIndex] = useState(undefined)

  const [selBackgroudColor, setSelBackgroudColor] = useState('#f8f9fa')
  const [selprimaryColor, setSelPrimaryColor] = useState('#1B8AE8')
  const [selsecondaryColor, setSelSecondaryColor] = useState('#6c757d')
  const [selTextColor, setSelTextColor] = useState('#212529')
  const [selLogo, setSelLogo] = useState('https://ui-avatars.com/api/?name=Avanquia&background=007bff&color=fff&size=128')

  const [proxies, setProxies] = useState<DevPortal[]>([]);
  const [allproxies, setAllProxies] = useState<DevPortal[]>([]);

  const [toggle, setToggle] = useState(true)

  const iframeRef = useRef(null);




    const AMBIENT_LABELS = {
      Yes: { name: 'Yes', color: '#2AA366' },        // Verde
      No: { name: 'No', color: '#FF6F5C' }, // Amarillo
      Unpublished: { name: 'Unpublished', color: '#EDA944' }
      //3: { name: 'Live', color: '#28a745' }, // Amarillo
    
    };
    
    const getAmbientLabel = (ambientId: string) => {
      if (ambientId==undefined || ambientId == null) return '';
     let ambient = undefined
      try{
      ambient = AMBIENT_LABELS[ambientId];
      } catch {}
      if (ambient==undefined) return (
        <span 
          style={{
            backgroundColor: '#2AA366',
            color: '#fff',
            padding: '2px 4px',
            borderRadius: '4px',
            fontSize: '12px',
            minWidth:'100px',
            display:'flex',
            width:'65px',
            justifyContent:'center',
            marginLeft:'auto',
            marginRight:'auto',
          }}
        >
          {ambientId || ''}
        </span>
      );
    
      return (
        <span 
          style={{
            backgroundColor: ambient.color,
            color: '#fff',
            padding: '2px 4px',
            borderRadius: '4px',
            fontSize: '12px',
            minWidth:'100px',
            display:'flex',
            width:'65px',
            justifyContent:'center',
            marginLeft:'auto',
            marginRight:'auto',
          }}
        >
          {ambient.name}
        </span>
      );
    };



  const whenClosing = ()=>{
    setshowUpgrade(false);
    
    }

  const [portalConfig, setPortalConfig] = useState({});
  const history = useHistory();
  const handleSaveProxy = async (newProxy: DevPortal) => {
    try {


      if (!newProxy.open) {
        setToggle(false); 
        SetSelectedService(newProxy.name)
      }else await fetchAPIProducts(selectedProjectId)
      setEditingProxy(null);
      setDrawerOpen(false);

      setEditingFlow(true)

      /*
      // Asegurarse de que normal_access se envíe correctamente
      if (newProxy.config) {
        newProxy.config.normal_access = Boolean(newProxy.config.normal_access);
      }
      
      console.log('Saving proxy with config:', newProxy);
      setEditingProxy(null);
      setDrawerOpen(false);
      
      await Promise.all([
        getProxies(),
        getCerts()
      ]);

      */
      
    } catch (error) {
      console.error('Error al guardar el proxy:', error);
    } finally {
      setDrawerOpen(false);
      setEditingProxy(null);
    }
  };



    const fetchProjects = async () => {
      history.push('/flow');
      setLoading(true);
      setProjects([]);
      try {
        //const response = await ObexRequestHandler.get(`/gateway/get_dev_portal_by_org?org_id=${SessionService.ORGANIZATION}`, {}, true)
        
        const response = (await ObexRequestHandler.get('/projects'));


        const projectsInfo = response.data || [];
        setProjects(projectsInfo);
        console.log(projectsInfo);
        setSelectedProjectId('');
        if (projectsInfo.length>0){
        setSelectedProjectId(projectsInfo[0].id)
        fetchAPIProducts(projectsInfo[0].id)
        } else {
          setApis([])
        }
      } catch (error) {
        console.error('Error fetching projects:', error);
      }
      
      setLoading(false);
      history.push('/flow');
    };



      const fetchAPIProducts = async (projects_id) => {
        try {
          const response = await ObexRequestHandler.get(`/get_flows/?obex_project_id=${projects_id}`, {}, true
          );
          const publishedApis = response.data || {};

          
          const products = publishedApis || [];
    
          if (products.length === 0) {
            console.warn('No API Products found for the selected project.');
          }
    
          setApiProducts(products.map((product) => ({ id: product.id, name: product.id_service })));

          //const proo = products.map((product) => ({ id: product.id, name: product.id_service }))
        
                const filtered = products.filter((proxy) =>
                  proxy.id_service.toLowerCase().includes(filtro.toLowerCase())
                );
                setAllProxies(products);
                setProxies(products);
                setFilteredProxies(filtered);




          setInitialized(true);
        } catch (error) {
          console.error('Error fetching API Products:', error);
          setInitialized(true);
          setApiProducts([]);
        } finally {
          setLoadingApiProducts(false);
          setInitialized(true);
        }
        setInitialized(true);
      }




  const getConsumption = async (disableCache = false) => {
    const result = await ObexRequestHandler.get('/consumption', {}, !disableCache);
    const { success, data } = result;
    if (success) {
 
      SetCurrentsuscripcion(data.subscriptionInfo.subscription_id);

    }
  }



    const getConnectors = async (iframe: any, themeButton: any, disableCache = false) => {

 
    const projects = (await ObexRequestHandler.get(`/info_low_code_api_service_dp?obex_project_id=${selectedProjectId}&id_service=${selected_service}`)).data;
            
    const result = await ObexRequestHandler.get(`/get_connectors?obex_project_id=${selectedProjectId}`, {}, !disableCache);
    
    console.log(result);
    
    let { success, data } = result;

    console.log(success);
    if (success == undefined){success = true; data=[]}
    if (success) {
      
        const apis = await ObexRequestHandler.get(`/publishing/get_apis_by_products_by_proj?obex_project_id=${selectedProjectId}`, {}, !disableCache);

        sendMessageToWebView('updateSequence',JSON.stringify(projects.sequence),data,apis,['Logic','Requests','Strings','Variables','Date'])

        setTimeout(()=>{
                  const iframeDocument = iframe.contentWindow.document;
        
        themeButton = iframeDocument.getElementById('add-tag-button2');

        if (themeButton) {
          themeButton.addEventListener('click', handleClickInsideIframe);
        } else {
          console.log('No se encontró el botón del tema en el iframe.');
        }
        }, 500)





    }
  }





  const handleOpenDrawer = async (proxy?:any) => {
    if (proxy) { 

      SetSelectedService(proxy.id_service);
      // setToggle(false);
      
      // setEditingFlow(true)

      //return;
      
      //const logo = await ObexRequestHandler.get(`/publishing/get_dev_portal_logo/${proxy.basePath.replace('/_', '')}`, {}, true)
      //const config_h = await ObexRequestHandler.get(`/publishing/get_dev_portal_config/${proxy.basePath.replace('/_', '')}`, {}, true)
      
      //const { data } = config_h;

      let config_theme = {
        backgroundColor: '#f8f9fa',
        primaryColor: '#1B8AE8',
        secondaryColor: '#6c757d',
        textColor: '#212529',
        logo: '',
        layout: 1,
        visibility: false,
        normal_access: false,
        environment_id: 0
      }
/*
      if (data && data.theme) {
        // Asegurarse de que normal_access se lea correctamente del servidor
        const normalAccess = data.theme.normal_access === true;
        
        config_theme = {
          ...config_theme,
          backgroundColor: data.theme.backgroundColor || config_theme.backgroundColor,
          primaryColor: data.theme.primaryColor || config_theme.primaryColor,
          secondaryColor: data.theme.secondaryColor || config_theme.secondaryColor,
          textColor: data.theme.textColor || config_theme.textColor,
          logo: logo.data.logo || config_theme.logo,
          visibility: typeof data.theme.visibility === 'boolean' ? data.theme.visibility : false,
          layout: data.theme.layout || config_theme.layout,
          normal_access: normalAccess, // Usar el valor explícitamente convertido
          environment_id: data.environment
        }
        
        proxy.config = {...config_theme};
        setPortalConfig({...config_theme});
      }
*/


    setEditingProxy(
      proxy || {
        id: undefined,
        basePath: '',
        name: proxy.id_service,
        description: proxy.description,
        products: [],
        projects: selectedProjectId,
        normal_access: false,
        environment: { name:'', id:0 },
        has_sandbox: false,
        endpoint: proxy.endpoint,
        config: {
          backgroundColor: '#f8f9fa',
          primaryColor: '#1B8AE8',
          secondaryColor: '#6c757d',
          textColor: '#212529',
          logo: '',
          visibility: false,
          layout: 1,
          normal_access: false,
        }
      }
    );
    
    setDrawerOpen(true);



return;
    }

    
    setEditingProxy(
      proxy || {
        id: undefined,
        basePath: '',
        name: '',
        description: '',
        products: [],
        projects: [],
        normal_access: false,
        environment: { name:'', id:0 },
        has_sandbox: false,
        config: {
          backgroundColor: '#f8f9fa',
          primaryColor: '#1B8AE8',
          secondaryColor: '#6c757d',
          textColor: '#212529',
          logo: '',
          visibility: false,
          layout: 1,
          normal_access: false,

        }
      }
    );
    
    setDrawerOpen(true);
  };




  const handleOpenDrawerCompose = async (proxy?:any) => {
    if (proxy) { 

      SetSelectedService(proxy.id_service);
      setToggle(false);
      
      setEditingFlow(true)

      return;
      /*
      const logo = await ObexRequestHandler.get(`/publishing/get_dev_portal_logo/${proxy.basePath.replace('/_', '')}`, {}, true)
      const config_h = await ObexRequestHandler.get(`/publishing/get_dev_portal_config/${proxy.basePath.replace('/_', '')}`, {}, true)
      
      const { data } = config_h;

      let config_theme = {
        backgroundColor: '#f8f9fa',
        primaryColor: '#1B8AE8',
        secondaryColor: '#6c757d',
        textColor: '#212529',
        logo: '',
        layout: 1,
        visibility: false,
        normal_access: false,
        environment_id: 0
      }

      if (data && data.theme) {
        // Asegurarse de que normal_access se lea correctamente del servidor
        const normalAccess = data.theme.normal_access === true;
        
        config_theme = {
          ...config_theme,
          backgroundColor: data.theme.backgroundColor || config_theme.backgroundColor,
          primaryColor: data.theme.primaryColor || config_theme.primaryColor,
          secondaryColor: data.theme.secondaryColor || config_theme.secondaryColor,
          textColor: data.theme.textColor || config_theme.textColor,
          logo: logo.data.logo || config_theme.logo,
          visibility: typeof data.theme.visibility === 'boolean' ? data.theme.visibility : false,
          layout: data.theme.layout || config_theme.layout,
          normal_access: normalAccess, // Usar el valor explícitamente convertido
          environment_id: data.environment
        }
        
        proxy.config = {...config_theme};
        setPortalConfig({...config_theme});
      }

*/

    }

    
    setEditingProxy(
      proxy || {
        id: undefined,
        basePath: '',
        name: '',
        description: '',
        products: [],
        projects: [],
        normal_access: false,
        environment: { name:'', id:0 },
        has_sandbox: false,
        config: {
          backgroundColor: '#f8f9fa',
          primaryColor: '#1B8AE8',
          secondaryColor: '#6c757d',
          textColor: '#212529',
          logo: '',
          visibility: false,
          layout: 1,
          normal_access: false,

        }
      }
    );
    
    setDrawerOpen(true);
  };





  
  const [showDelete, setShowDelete] = useState(false);
  const [selDeveloper, setSelDeveloper] = useState({id:'' })
  const [selTeam, setselTeam] = useState({id:0, type:'', name:''});

  const handleShowDelete = () => {
    setShowDelete(!showDelete);
    setToggle(true);
    
  }

  const handleDelete = async (developer) => {
    setShowDelete(true);
    setSelDeveloper(developer);
    setselTeam(developer);

  }



  const publish = async (proxy) => {

    try{

      await ObexRequestHandler.get(`/publish_flows?id=${proxy.id}`);
      fetchAPIProducts(selectedProjectId);

    } catch {

    }

  }


    const unpublish = async (proxy) => {

    try{

      await ObexRequestHandler.get(`/unpublish_flows?id=${proxy.id}`);
      fetchAPIProducts(selectedProjectId);

    } catch {

    }

  }





  const sendMessageToWebView = async (type: string, message: any, connectors: any, apis: any, toolbox: any) => {

    const iframe = iframeRef.current;
    if (iframe && iframe.contentWindow) {
      const mensaje = {
        command: type,
        value: String(message),
        connectors: connectors,
        apis: apis,
        toolbox: toolbox
      };
      iframe.contentWindow.postMessage(mensaje, '*');
    }

  }


  const handleDeleteProxy = async (proxy) => {
   
      handleShowDelete();

      await ObexRequestHandler.post(`/del_flows?name=${proxy.id_service}&obex_project_id=${selectedProjectId}`)
    
    

    fetchAPIProducts(selectedProjectId)

    history.push('/flow')
    
  };


  const getCerts = async () => {
    const certs = await ObexRequestHandler.get(`/cert/get_certs?organization=${SessionService.ORGANIZATION}`)

    setCertsT(certs.data);
    history.push('/flow')
  };


  const getProxies = async () => {
    setLoading(true);
    try {
      const proxies_configs = await ObexRequestHandler.get(
        `/gateway/get_dev_portal_by_org?org_id=${SessionService.ORGANIZATION}`, 
        {}, 
        true
      );

      console.log('Datos crudos del API:', proxies_configs.data);

      const proxies = proxies_configs.data.map((prox) => {
        console.log('Configuración individual del portal:', prox);
        return {
          basePath: prox.route,
          id: prox.id,
          name: prox.name,
          description: prox.description,
          products: prox.associated_products,
          projects: prox.associated_projects,
          normal_access: prox.normal_access,
          environment: {id:prox.environment_id, name: prox.alias},
          config: prox.config || {} // Verificar si config existe
        };
      });

      console.log('Proxies procesados:', proxies);

      const filtered = proxies.filter((proxy) =>
        proxy.basePath.toLowerCase().includes(filtro.toLowerCase())
      );
      
      setAllProxies(proxies);
      setProxies(proxies);
      setFilteredProxies(filtered);
    } catch (error) {
      console.error('Error al cargar los portales:', error);
    } finally {
      setLoading(false);
    }
  };



  const changeFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setFiltro(newValue);
    filterProjects(newValue);
  };

  const filterProjects = (searchTerm: string) => {
    if (!allproxies) return; // Protección contra undefined

    const filter_projects = allproxies.filter(element =>
      element.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setProxies(searchTerm === '' ? allproxies : filter_projects);
    setFilteredProxies(searchTerm === '' ? allproxies : filter_projects);
  };



  document.addEventListener('updateView', (e) => {
    if (SessionService.updating>0 && location.pathname == '/flow'){
      history.push('/flow')
      SessionService.updating = SessionService.updating -3;

      /*
      getProxies(),
      getCerts()
      */

      fetchAPIProducts(selectedProjectId);

    window.scrollTo(0, 0);
    history.push('/flow')
    }
  
  }, false);



  useEffect(()=>{

    fetchProjects();
  },[])



  useEffect(() => {
    
    (window as any).comunicarAReact = (mensajeDelIframe: any) => {
      
      setvalueBin(mensajeDelIframe);
      setshowModalBin(true);

    };

    return () => {
      delete (window as any).comunicarAReact;
    };
  }, []);


    useEffect(() => {
    
    (window as any).comunicarAReact2 = async (mensajeDelIframe: any) => {
      

      console.log(mensajeDelIframe)

      console.log(projects);

      const body_post = {
        obex_project_id:selectedProjectId,
        value_json: JSON.stringify(mensajeDelIframe),
        id_service: selected_service

      }

      let response = await ObexRequestHandler.post(`/info_low_code_api_service_dp`,body_post);
      console.log(response)
      //setvalueBin(mensajeDelIframe);
      //setshowModalBin(true);

    };

    return () => {
      delete (window as any).comunicarAReact2;
    };
  }, [selectedProjectId, selected_service]);



  useEffect(() => {
    const iframe = iframeRef.current;

    // Se asegura de que el iframe exista en el DOM
    if (!iframe) {
      return;
    }
    let themeButton = null
    const handleIframeLoad = () => {
      try {




        getConnectors(iframe, themeButton);




      } catch (error) {
        console.error('Error al acceder al contenido del iframe:', error);
      }
    };

    // 5. Agrega el "listener" para el evento 'load'
    iframe.addEventListener('load', handleIframeLoad);

    // 6. Limpieza: Es importante remover el listener cuando el componente se desmonte
    return () => {
      iframe.removeEventListener('load', handleIframeLoad);
    };

  }, [editingFlow]); 


  const handleClickInsideIframe = async () => {

    setshowModal(true);
    

  }

  return (
    

<>
{ !toggle ?

<DashLayoutCanvas sider={DashRouters} active="proxies" sublinks={[]}>
                  <iframe
                    ref={iframeRef}
                    src="/editor.html"
                    title="Editor de Flujo"
                    style={{ 
                        width: '100%', 
                        height: '100%',
                        border: 'none' 
                    }}
                  />






      <Modal className="cloudModal modal-container footerModal" style={{ paddingTop: '7rem' }} show={showModal} onHide={handleClose2} container={document.getElementById('dashboardWrapper')}>
        <Modal.Header className='cloudModal modal-header'>Exit</Modal.Header>
        <Modal.Body className='cld_text'>Do you want exit from Diagram?</Modal.Body>
        <Modal.Footer className='cloudModal modal-footer'>
          <button 
          className="customButton-red modal-exit-buttons" 
          
          onClick={() => {
            setshowModal(false);
            setToggle(true);
            setEditingFlow(false);
            fetchAPIProducts(selectedProjectId)
          }}>
            See you later
          </button>
          <button className="customButton-blue modal-exit-buttons" 
          
          onClick={handleClose2}>
            Stay here
          </button>
        </Modal.Footer>
      </Modal>


      <Modal className="cloudModal modal-container footerModal" style={{ paddingTop: '7rem' }} show={showModalBin} onHide={handleClose2bin} container={document.getElementById('dashboardWrapper')}>
        <Modal.Header className='cloudModal modal-header'>Delete</Modal.Header>
        <Modal.Body className='cld_text'>Do you want to delete element?</Modal.Body>
        <Modal.Footer className='cloudModal modal-footer'>
          <button 
          className="customButton-red modal-exit-buttons" 
          
          onClick={() => {
            setshowModal(false);
            //setToggle(true);

            const iframe = iframeRef.current;
              if (iframe && iframe.contentWindow) {
                const mensaje = {
                  command: 'applyDeleteStep',
                  value: valueBin
                };
                console.log("enviando");
                iframe.contentWindow.postMessage(mensaje, '*');
              }

              setshowModalBin(false);

          }}>
            Delete
          </button>
          <button className="customButton-blue modal-exit-buttons" 
          
          onClick={handleClose2bin}>
            Keep
          </button>
        </Modal.Footer>
      </Modal>
      

</DashLayoutCanvas>

:
                  
                 
<DashLayout sider={DashRouters} active="proxies" sublinks={[]}>
      
      


      <Row id="topHeader">
        <Col md="10">
          <div className="cld_wrapperTitle">
            <img src={devIcon} alt="icon dashboard" />
            
            <span className="cld_title w-100 margin-y-24px">
              <span className="cld_index">Flows </span>/ Flows
              <p className="title_description">This is Flows</p>
            </span>
          </div>
        </Col>



        <Col md="2" className="align-content-center margin-y-24px">
          <button
          //setshowUpgrade
            //disabled={proxies.length >= limitDevPortals}
            style={{ width: '225px' }}
            className="btn-cmd btn-cmd-green-line float-right"
            onClick={() => {
              if (proxies.length >= limitDevPortals) {setshowUpgrade(true)}
                else handleOpenDrawer()
            }}>
            {Number(proxies.length) >= Number(limitDevPortals) ? 'Upgrade Plan' : 'Add Flow'}
          </button>
        </Col>




        <Col>
          <div className="customBorder"></div>
        </Col>
      </Row>


            <Row className="mt-5">








              <Col md='9' className="searchContainer" style={{display:'flex'}}>



            <Form.Group className="" style={{width:'100%', marginRight:'20px'}}>
              <Form.Control as="select" onChange={(e) => {

                setSelectedProjectId(e.target.value);
                fetchAPIProducts(e.target.value);

              }

              } value={selectedProjectId || ''}>
                <option value="">-- Select a project --</option>
                {projects.map((project) => (
                  <option key={project.id} value={project.id}>
                    {project.description}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>




                <Form.Control 
                        id='buscador' 
                        type="text" 
                        value={filtro || ''} // Asegurarse de que nunca sea undefined
                        placeholder="Search by Flow name"
                        onChange={changeFilter} 
                      />
                      {/*<Button
                        className="customButton-transparent px-4"
                        onClick={() => getProxies()}>
                        <FontAwesomeIcon icon={faSearch} size="1x" />
                </Button>*/}
              </Col>   
            </Row>





      <Row id='table' className='mt-4'>
        <Col>
          {loading ? (
            <Row style={{ textAlign: 'center' }}>
              <Col>
                <Spinner animation="border" style={{ marginLeft: '8px' }} />
              </Col>
            </Row>
          ) : (
            <div className='cld_borderWrapper'>
              <span className='cld_sectionTitle'>Flows</span>

              

              {((filteredProxies.length === 0 || proxies.length === 0) && initialized) ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
                  <Nodata />
                </div>
              ) : (
              <Table className="cld_tableWrapper">
                <tbody>
                  <tr className='tableRow'>
                    <th style={{ width: '10%' }} className='textBold'>ID</th>
                    <th style={{ width: '15%' }} className='textBold'>Name</th>
                    <th style={{ width: '15%', textAlign: 'center' }} className="textBold">Process Published</th>
                    <th style={{ width: '2w5%' }} className='textBold'>Description</th>
                    <th style={{ width: '15%' }} className='textBold'>Endpoint</th>
                    <th style={{ width: '15%' }} className='textBold'>Interface</th>

                    <th style={{ width: '20px', textAlign: 'end' }} className='textBold'>Actions</th>
                  </tr>


                  {(filteredProxies.length > 0 ? filteredProxies : proxies).map((proxy) => (

                    

                    <tr className="tableRow" key={proxy.id}>
                      <td className='td_centered'>{proxy.id}</td>
                      <td className='td_centered'>{proxy.id_service}</td>
                      <td className="td_centered">{proxy.published_flow ? getAmbientLabel('Yes') : getAmbientLabel('No')}</td>
                      <td className='td_centered'>{proxy.description}</td>
                      <td className='td_centered'>{proxy.endpoint || ''}</td>
                      <td className='td_centered'></td>
                      <td className="td_centered text-right">
                        <div className="actionsWrapper d-flex justify-content-center align-items-center h-100">
                          <Dropdown className="my-auto" style={{ marginRight:'2px' }}>
                            <Dropdown.Toggle variant="" className="icon-edit-table">
                              <FontAwesomeIcon
                              className="icon-edit-table" 
                              icon={faEllipsisV} />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item key={1} onClick={() => handleOpenDrawer(proxy)}>
                                Edit
                              </Dropdown.Item>
                              <Dropdown.Item key={1} onClick={() => handleOpenDrawerCompose(proxy)}>
                                View on Compose
                              </Dropdown.Item>
                              <Dropdown.Item key={2} onClick={() => handleDelete(proxy)}>
                                Delete
                              </Dropdown.Item>
                      {
                        proxy.published_flow ? 
                              <Dropdown.Item key={2} onClick={() => unpublish(proxy)}>
                                Unpublish
                              </Dropdown.Item>:
                              <Dropdown.Item key={2} onClick={() => publish(proxy)}>
                                Publish
                              </Dropdown.Item>
                      }
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </td>
                    </tr>


                  ))}
                </tbody>
              </Table>
              )}
            </div>
          )}
        </Col>
      </Row>


      
      
      <Drawer
      index="developer_portal"
        isOpen={drawerOpen}
        toggleSidebar={() => {
          setDrawerOpen(false);
          setEditingProxy(null);
        }}
        name={!(editingProxy?.basePath == '') ? 'Edit Flow' : 'Add Flow'}
      >
        <></>

        <FlowsForm
          opened={drawerOpen}
          isEditing={!(editingProxy?.basePath == '')}
          id={editingProxy?.id}
          basePath={editingProxy?.basePath || ''}
          name={editingProxy?.id_service || ''}
          description={editingProxy?.description || ''}
          products={editingProxy?.products || []}
          projects={[selectedProjectId]}
          environment={editingProxy?.environment || { name:'', id:0 }}
          has_sandbox={editingProxy?.has_sandbox || false}
          normal_access={editingProxy?.normal_access || false}
          config={portalConfig || {}}
          endpoint={editingProxy?.endpoint || ''}
          onSubmit={handleSaveProxy}
        />
      </Drawer>

      <ConfirmDeletetModal 
          handleSubmit={()=>handleDeleteProxy(selDeveloper)} 
          showModal={showDelete}
          onCloseModal={handleShowDelete}
          loading={false}
          error={''}
          success={''}
          name_to_check={'DELETE'}
          title_to_show={`Confirm delete Dev Portal ${selTeam.name}`}
        />


        <UpgradePlanModal 
          showModal={ showUpgrade } 
          text={'In order to create a developer portal you need to upgrade your plan. \n You have consumed the maximun slots available.'} 
          onCloseModal={whenClosing} 
          onCancelModal={whenClosing} 
          currentSuscription={currentSuscription}
          onSuccess={whenClosing}
          />


    </DashLayout>
}
    </>
  );
};

export default Flow;
